import { Box, CircularProgress, Container, Grid, Paper, styled } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

class ConsultaCalificacionesUsuarios extends Component {
    constructor(props){
        super(props);
        this.state = {
            errores: null,
            notificaciones: null,
            loading: false,
            calificacionFun: {
                numeroFuncionario: '',
                anio: '',
            },
            numeroNombre: [],
            consultaRealizada: false,
            calificaciones: null,

            modalDescargo: {
                realizaDescargo: '0',
                descargo: '',
            },
        }

        this.manejarCambiosCalificacion = this.manejarCambiosCalificacion.bind(this);
        this.manejarEnvioConsulta = this.manejarEnvioConsulta.bind(this);
    }

    async componentDidMount(){
            const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
            const datosNumNom = await numNom.json();
            this.setState({
                numeroNombre: datosNumNom,
            });
    }

    render(){
        return (
            <>
                <h3>Calificaciones</h3>
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.consultaRealizada
                ?
                    null
                :
                    <Box sx={{ flexGrow: 1}} >
                        <Grid container spacing={2} rowSpacing={1}>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={2}>
                                <Item>Número Funcionario</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.calificacionFun.numeroFuncionario} onChange={this.manejarCambiosCalificacion} type="text" />
                            </Grid>
                            <Grid item xs={2}>
                                <Item>Año</Item>
                            </Grid>
                            <Grid item xs={2}>
                                <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.calificacionFun.anio} onChange={this.manejarCambiosCalificacion} type="number" />
                            </Grid>
                            <Grid item xs={2}>

                            </Grid>
                            <Grid item xs={5}>
                                
                            </Grid>
                            <Grid item xs={2}>
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioConsulta}>Consultar</button>
                            </Grid>
                            
                        </Grid>
                    </Box>
                }
                <Container>
                    <br/>
                    {this.state.consultaRealizada
                    ?
                        <Container>
                            <fieldset>
                                <legend>DATOS FUNCIONARIO</legend>
                                <fieldset>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Número Funcionario</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.numeroFuncionario}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Nombre Funcionario</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.nombreFuncionario}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Escalafon</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.escalafon}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Serie</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.serie}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Cargo</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.cargo}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Grado</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.grado}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Ubicación</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.lugar}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            {this.state.calificaciones.lugarCentral !== -1
                                            ?
                                                <Grid item xs={2}>
                                                    <Item>Ubicación Central</Item>
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.calificaciones.lugarCentral !== -1
                                            ?
                                                <Grid item xs={2}>
                                                    {this.state.calificaciones.lugarCentral}
                                                </Grid>
                                            :
                                                null
                                            }
                                            {this.state.calificaciones.lugarCentral !== -1
                                            ?
                                                <Grid item xs={2}>
                                                    
                                                </Grid>
                                            :
                                                null
                                            }
                                            <Grid item xs={2}>
                                                <Item>Supervisión</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.conSupervision}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Año</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.anio}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>RENDIMIENTO Y CALIDAD</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Cantidad de trabajo</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.cantidadTrabajo}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Calidad de la labor realizada</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.calidadLaboral}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Procupación por el servicio o usuario</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.preocupacionServicio}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={5}>
                                                
                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.promedioRC}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>CONDICIONES PERSONALES</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Conocimiento del trabajo</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.conocimientoTrabajo}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Interés por el trabajo</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.interesTrabajo}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Capacidad para realizar trabajos en grupo</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.capacidadTrabajo}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>relaciones interpersonales</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.relacionesInterpersonales}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.promedioCP}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>COMPORTAMIENTO DEL FUNCIONARIO</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Asistencia y puntualidad</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.asistenciaPuntualidad}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Cumplimiento de normas e instrucciones</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.cumplimientoNormas}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.promedioCDF}
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                                <fieldset>
                                    <legend>APTITUDES EN CARGOS DE SUPERVISION Y RESPONSABILIDAD</legend>
                                    <p>Puntajes del 1 al 5</p>
                                    <Box sx={{ flexGrow: 1}}>
                                        <Grid container spacing={2} rowSpacing={1}>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Supervisión</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.supervision}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Logro de metas</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.logroMetas}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Iniciativa</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.iniciativa}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Compromiso</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.compromiso}
                                            </Grid>
                                            <Grid item xs={1}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Responsabilidad</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.responsabilidad}
                                            </Grid>
                                            <Grid item xs={1}>

                                            </Grid>
                                            <Grid item xs={5}>

                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Promedio</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.aptitudesCSR}
                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={4}>
                                                
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Promedio Total</Item>
                                            </Grid>
                                            <Grid item xs={2}>
                                                {this.state.calificaciones.puntaje}
                                            </Grid>
                                            <Grid item xs={5}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Observaciones</Item>
                                            </Grid>
                                            <Grid item xs={3}>

                                            </Grid>
                                            <Grid item xs={12}>
                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='comentarios' value={this.state.calificaciones.comentarios} disabled/>
                                            </Grid>
                                            <Grid item xs={3}>

                                            </Grid>
                                            <Grid item xs={3}>
                                                <Item>¿Desea realizar un descargo?</Item>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <select disabled={true} style={{width:"100%", border:"2px solid #D6EAF8"}} id='realizaDescargo'  value={this.state.modalDescargo.realizaDescargo} onChange={this.manejarCambioModalDescargo}>
                                                    <option key={0} value={0}>NO</option>
                                                    <option key={1} value={1}>SI</option>
                                                </select>
                                            </Grid>
                                            <Grid item xs={3}>

                                            </Grid>
                                            <Grid item xs={5}>

                                            </Grid>
                                            <Grid item xs={2}>
                                                <Item>Descargo</Item>
                                            </Grid>
                                            <Grid item xs={5}>

                                            </Grid>
                                            <Grid item xs={12}>
                                                <textarea style={{border: "2px solid #D6EAF8", width: "100%"}} id='descargo' value={this.state.calificaciones.descargoFuncionario} disabled />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </fieldset>
                            </fieldset>
                            {this.state.calificaciones.estadoCalificacion === 0
                            ?
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioNotificacion}>Notificar</button>
                            :
                                this.state.calificaciones.estadoCalificacion === 4
                                ?
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioNotificacionTribunal}>Notificar</button>
                                :
                                    null
                            }
                            {/*this.state.calificaciones.estadoCalificacion === 4 ? <button className="btn btn-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null*/}
                        </Container>
                    :
                        null
                    }
                </Container>
            </>
        )
    }

    manejarCambiosCalificacion(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
        })
        this.setState(state => {
            const calificacionActu = state.calificacionFun;
            if((clave === 'numeroFuncionario') && (valor !== '')){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                    {if(name.numeroFuncionario === valor){
                        calificacionActu['nombreFuncionario'] = name.primerNombre + ' ' + name.primerApellido;
                        aux = false;
                    }else if(aux){
                        calificacionActu['nombreFuncionario'] = '';
                    }
                });
            }else if((clave === 'numeroFuncionario') && (valor === '')){
                calificacionActu['nombreFuncionario'] = '';
            }
            calificacionActu[clave] = valor;
            return{
                calificacionFun: calificacionActu,
            };
        });
    }

    async manejarEnvioConsulta(e){
        e.preventDefault();
        if((this.state.calificacionFun.anio === '') && (this.state.tipoCalificacion === '1')){
            this.setState({
                errores: 'Debe seleccionar el año de la calificación',
                notificaciones: null,
            });
        }else{
            const cargaUtil = JSON.stringify([this.state.calificacionFun.numeroFuncionario, 1, this.state.calificacionFun.anio]);
            
            const control = await fetch(`${Constantes.RUTA_API}/obtener_calificacionFuncionario.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res[0],
            });
            
            if(res[0] === 'ok'){
                this.setState({
                    notificaciones: null,
                    errores: null,
                    calificaciones: res[1],
                    consultaRealizada: true,
                });
            }
            if(res[1].descargoFuncionario !== ''){
                this.setState(state => {
                    const descar = state.modalDescargo;
                    descar['realizaDescargo'] = 1;
                    return{
                        modalDescargo: descar,
                    };
                });
            }
        }
    }
}

export default ConsultaCalificacionesUsuarios